<template>
    <div :class='["scroll-bar-" + this.axis,down?"ismove":""]'
         @mousedown="this.downHandler"
         :style="barStyle">
    </div>
</template>
<script>
    const BAR = {
        x: {
            client: 'clientWidth',
            mousePosition: 'clientX',
            offset: 'offsetWidth',
            scroll: 'scrollLeft',
            position: 'left',
            axisSize: 'width',
            move: 0,
            size: 0
        },
        y: {
            client: 'clientHeight',
            mousePosition: 'clientY',
            offset: 'offsetHeight',
            scroll: 'scrollTop',
            position: 'top',
            axisSize: 'height',
            move: 0,
            size: 0
        }
    }

    export default {
        name: 'bar',
        data() {
            return {
                mouse: {
                    y: 0,
                    x: 0
                },
                down: false,
                move: this.initialMove,
                size: this.initialSize
            }
        },
        props: ['axis','initialMove','initialSize'],
        computed: {
            scrollWrap() {
                return this.$parent
            },
            bar() {
                return BAR[this.axis]
            },
            barStyle() {
                return {
                    [BAR[this.axis].axisSize]: this.size + '%',
                    [BAR[this.axis].position]: this.move + '%',
                }
            }
        },
        watch: {
            'initialSize': function (newV) {
                this.size = newV
            },
            'initialMove':function (newV) {
                this.move = newV
            },

        },
        methods: {
            downHandler(e) {
                this.down = true;
                this.mouse[this.axis] = e[this.bar.mousePosition];
                document.addEventListener('mousemove', this.startMove)
                document.addEventListener('mouseup', this.upHandler)
            },
            upHandler() {
                this.down = false;
                document.removeEventListener('mousemove', this.startMove)
                document.removeEventListener('mouseup', this.upHandler)
            },
            startMove(e) {
                if (!this.down) return;
                if(this.mouse[this.axis] === e[this.bar.mousePosition]) return;
                if (e.button === 0 && e.buttons === 1 && this.down) {
                    this.move += (e[this.bar.mousePosition] - this.mouse[this.axis]) / this.scrollWrap.$el[this.bar.offset] * 100;
                    if (this.move <= 0) {
                        this.move = 0;
                        this.scrollWrap.scrollView[this.bar.scroll] = this.move * this.scrollWrap.viewWrap[this.bar.client] / 100
                        return false;
                    } else if (this.move + this.size > 100) {
                        this.move = 100 - this.size;
                        this.scrollWrap.scrollView[this.bar.scroll] = this.move * this.scrollWrap.viewWrap[this.bar.client] / 100
                        return false
                    }
                    this.scrollWrap.scrollView[this.bar.scroll] = this.move * this.scrollWrap.viewWrap[this.bar.client] / 100
                    this.mouse[this.axis] = e[this.bar.mousePosition];
                }
            }
        },
    }
</script>
<style>

</style>

